import type { EvoProfileResponseType, ProfileMeta } from "../../../types";

import type { Builder } from "./Builder";

export class ProfileDataBuilder implements Builder<EvoProfileResponseType> {
  _body: EvoProfileResponseType = {
    data: {
      consumer: {
        email: "adadas@asd.pl",
        first_name: "personalInfo firstname",
        last_name: "personalInfo lastname",
        date_of_birth: "01.01.2004",
        phone: "49987654321",
        gender: "male",
        addresses: [],
        custom_attributes: {},
        uuid: "143478aaaa",
      },
      purposes: [],
      has_registered_device: false,
      is_pending_email_verification: false,
    },
    meta: { allow_date_of_birth_update: true },
  };

  constructor(person: Partial<EvoProfileResponseType>) {
    this._body = { ...this._body, ...person };
  }

  setConsumer(value: EvoProfileResponseType["data"]["consumer"]): this {
    this._body.data.consumer = value;
    return this;
  }

  setAddresses(value: EvoProfileResponseType["data"]["consumer"]["addresses"]): this {
    this._body.data.consumer.addresses = value;
    return this;
  }

  setPhone(value: string): this {
    this._body.data.consumer.phone = value;
    return this;
  }

  setIsAgeVerified(value: boolean): this {
    this._body.data.consumer.custom_attributes = {
      ...this._body.data.consumer.custom_attributes,
      is_age_verified: value.toString(),
    };
    return this;
  }
  setIsPendingEmailVerification(value: boolean): this {
    this._body.data.is_pending_email_verification = value;
    return this;
  }
  setPurposes(value: string[]): this {
    this._body.data.purposes = value;
    return this;
  }
  setData(value: EvoProfileResponseType["data"]): this {
    this._body.data = value;
    return this;
  }
  setMeta(value: ProfileMeta): this {
    this._body.meta = value;
    return this;
  }
  setHasRegisteredDevice(value: boolean): this {
    this._body.data.has_registered_device = value;
    return this;
  }
  setCustomAttributes(value: Record<string, string>): this {
    this._body.data.consumer.custom_attributes = value;
    return this;
  }
  build(): EvoProfileResponseType {
    return this._body;
  }
}
